/* global window */
(function () {
  if (window.JIYUCHO_SCHEDULE) return;

  function parseAsJSTLocalInput(value) {
    if (!value) return null;
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : new Date(value.getTime());
    }
    var v = String(value).trim().replace(/\//g, "-").replace(" ", "T");
    var m = v.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:T(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
    if (!m) return null;
    return jstDate(
      parseInt(m[1], 10),
      parseInt(m[2], 10),
      parseInt(m[3], 10),
      parseInt(m[4] || "0", 10),
      parseInt(m[5] || "0", 10),
      parseInt(m[6] || "0", 10)
    );
  }

  function jstDate(y, m, d, h, mi, s) {
    h = h || 0;
    mi = mi || 0;
    s = s || 0;
    var mm = String(m).padStart(2, "0");
    var dd = String(d).padStart(2, "0");
    var hh = String(h).padStart(2, "0");
    var mn = String(mi).padStart(2, "0");
    var ss = String(s).padStart(2, "0");
    return new Date(y + "-" + mm + "-" + dd + "T" + hh + ":" + mn + ":" + ss + "+09:00");
  }

  function getJstComponents(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) return null;
    var d = new Date(date.getTime() + 9 * 60 * 60 * 1000);
    return {
      y: d.getUTCFullYear(),
      m: d.getUTCMonth() + 1,
      d: d.getUTCDate(),
      dow: d.getUTCDay(),
      h: d.getUTCHours(),
      mn: d.getUTCMinutes(),
      ymd:
        d.getUTCFullYear() +
        "-" +
        String(d.getUTCMonth() + 1).padStart(2, "0") +
        "-" +
        String(d.getUTCDate()).padStart(2, "0")
    };
  }

  function isSameJstDay(a, b) {
    return getJstComponents(a).ymd === getJstComponents(b).ymd;
  }

  function isTooLateTomorrowJST(now, sel) {
    var tom = new Date(now.getTime() + 24 * 60 * 60 * 1000);
    var nowJ = getJstComponents(now);
    return isSameJstDay(sel, tom) && nowJ.h >= 21;
  }

  function parseSheetToDateJST(s) {
    if (!s) return null;
    if (s instanceof Date) return isNaN(s.getTime()) ? null : new Date(s.getTime());
    var normalized = String(s).trim().replace(/\//g, "-").replace(" ", "T");
    if (/[zZ]|[+-]\d{2}:\d{2}$/.test(normalized)) return new Date(normalized);
    return parseAsJSTLocalInput(normalized);
  }

  function formatJstLocalInput(date) {
    var J = getJstComponents(date);
    if (!J) return "";
    return J.ymd + "T" + String(J.h).padStart(2, "0") + ":" + String(J.mn).padStart(2, "0");
  }

  function getJstMinutes(date) {
    var J = getJstComponents(date);
    return J ? J.h * 60 + J.mn : NaN;
  }

  var holidaySet = new Set([
    "2024-12-23",
    "2025-01-01","2025-01-13","2025-02-11","2025-02-24","2025-03-20",
    "2025-04-29","2025-04-30","2025-05-01","2025-05-02","2025-05-03",
    "2025-05-04","2025-05-05","2025-05-06","2025-07-21","2025-08-11",
    "2025-09-15","2025-09-23","2025-10-13","2025-11-03","2025-11-23",
    "2025-11-24","2025-12-29",
    "2026-01-12","2026-02-11","2026-02-23","2026-03-20",
    "2026-04-29","2026-05-03","2026-05-04","2026-05-05","2026-05-06",
    "2026-07-20","2026-08-11","2026-09-21","2026-09-22","2026-09-23",
    "2026-10-12","2026-11-03","2026-11-23",
    "2027-01-01","2027-01-11","2027-02-11","2027-02-23","2027-03-21",
    "2027-03-22","2027-04-29","2027-05-03","2027-05-04","2027-05-05",
    "2027-07-19","2027-08-11","2027-09-20","2027-09-23","2027-10-11",
    "2027-11-03","2027-11-23"
  ]);

  function isHolidayInJapan(date) {
    return holidaySet.has(getJstComponents(date).ymd);
  }

  function isInHolidaySeason(date) {
    var J = getJstComponents(date);
    var startA = jstDate(J.y, 12, 30, 0, 0, 0);
    var endA = jstDate(J.y + 1, 1, 6, 23, 59, 59);
    var startB = jstDate(J.y, 1, 1, 0, 0, 0);
    var endB = jstDate(J.y, 1, 6, 23, 59, 59);
    return (date >= startA && date <= endA) || (date >= startB && date <= endB);
  }

  function ymdKey(date) {
    var J = getJstComponents(date);
    return (
      String(J.y) +
      String(J.m).padStart(2, "0") +
      String(J.d).padStart(2, "0")
    );
  }

  function getSpecialHours(rules, date) {
    var map = rules && rules.specialHours;
    if (!map) return null;
    return map[ymdKey(date)] || null;
  }

  var STORE_RULES = {
    JIYUCHO: {
      // 時短営業や定休日以外の臨時休業日設定はこちらにて
      specialHours: {
        // 例 終日 close にしたい日
        // "20260105": { closed: true }

        // 例 時短にしたい日
        "20251229": { openMin: 600, closeMin: 1020 }
      },
      closedByDow: function (date) {
        var J = getJstComponents(date);
        if (isHolidayInJapan(date)) return false;
        return J.dow === 1 || J.dow === 2;
      },
      offHours: function (date) {
        var J = getJstComponents(date);
        var sp = getSpecialHours(this, date);
        if (sp && sp.closed) return true;

        var mins = J.h * 60 + J.mn;

        if (sp && typeof sp.openMin === "number" && typeof sp.closeMin === "number") {
          return mins < sp.openMin || mins >= sp.closeMin;
        }

        var holiday = isHolidayInJapan(date);
        var weekend = J.dow === 0 || J.dow === 6;

        if (holiday || weekend) return mins < 600 || mins >= 1200;
        return mins < 780 || mins >= 1080;
      }
    },

    FUTO: {
      // 時短営業や定休日以外の臨時休業日設定はこちらにて
      specialHours: {
        // ここに FUTO の例外日を入れる
        // 12 29 を 10 00 から 17 00（分単位で設定）
        "20251229": { openMin: 600, closeMin: 1020 }
      },
      closedByDow: function (date) {
        var J = getJstComponents(date);
        if (isHolidayInJapan(date)) return false;
        return J.dow === 2;
      },
      offHours: function (date) {
        var J = getJstComponents(date);
        var sp = getSpecialHours(this, date);
        if (sp && sp.closed) return true;

        var mins = J.h * 60 + J.mn;

        if (sp && typeof sp.openMin === "number" && typeof sp.closeMin === "number") {
          return mins < sp.openMin || mins >= sp.closeMin;
        }

        var holiday = isHolidayInJapan(date);
        var weekend = J.dow === 0 || J.dow === 6;

        if (holiday || weekend) return mins < 600 || mins >= 1200;
        return mins < 780 || mins >= 1080;
      }
    }
  };

  function checkReservationDate(date, storeKey) {
    if (isInHolidaySeason(date)) return { ok: false, key: "notBusiness" };
    var rules = STORE_RULES[storeKey] || STORE_RULES.JIYUCHO;
    var sp = getSpecialHours(rules, date);
    if (sp && sp.closed) return { ok: false, key: "notBusiness" };
    if (rules.closedByDow(date)) return { ok: false, key: "notBusiness" };
    return { ok: true };
  }

  function isBusinessDateTime(date, storeKey) {
    var r = checkReservationDate(date, storeKey);
    if (!r.ok) return r;
    var rules = STORE_RULES[storeKey] || STORE_RULES.JIYUCHO;
    if (rules.offHours(date)) return { ok: false, key: "notBusiness" };
    return { ok: true };
  }

  function getBusinessHours(date, storeKey) {
    var rules = STORE_RULES[storeKey] || STORE_RULES.JIYUCHO;
    var sp = getSpecialHours(rules, date);
    if (sp && sp.closed) return null;

    var openMin;
    var closeMin;
    if (sp && typeof sp.openMin === "number" && typeof sp.closeMin === "number") {
      openMin = sp.openMin;
      closeMin = sp.closeMin;
    } else {
      var J = getJstComponents(date);
      var holiday = isHolidayInJapan(date);
      var weekend = J.dow === 0 || J.dow === 6;
      openMin = holiday || weekend ? 600 : 780;
      closeMin = holiday || weekend ? 1200 : 1080;
    }
    function toHm(min) {
      var h = Math.floor(min / 60);
      var m = min % 60;
      return String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
    }
    return { open: toHm(openMin), close: toHm(closeMin) };
  }

  function normalizeStoreKey(storeKey) {
    var key = String(storeKey || "").trim().toUpperCase();
    return key === "FUTO" || key === "F" || key === "封灯" ? "FUTO" : "JIYUCHO";
  }

  function normalizeMenuText(menu) {
    return String(menu || "").toLowerCase().replace(/[\s\u3000]+/g, "");
  }

  function isLetterReservationMenu(menu) {
    var text = normalizeMenuText(menu);
    if (!text) return false;
    if (
      text.indexOf("acupofletter") >= 0 ||
      text.indexOf("acol") >= 0 ||
      text.indexOf("②") >= 0
    ) return false;
    return text.indexOf("①") >= 0 ||
      text.indexOf("t-price") >= 0 ||
      text.indexOf("future") >= 0 ||
      text.indexOf("一年後の自分へ手紙を書く") >= 0 ||
      text.indexOf("手紙") >= 0 ||
      text.indexOf("letter") >= 0 ||
      text.indexOf("writealettertoyourfutureself") >= 0;
  }

  function getMenuLimitOffsetMinutes(menu) {
    return isLetterReservationMenu(menu) ? 90 : 30;
  }

  function getLatestReservableStartMinutes(date, storeKey, menu) {
    var hours = getBusinessHours(date, normalizeStoreKey(storeKey));
    if (!hours || !hours.close) return null;
    var parts = String(hours.close).split(":");
    if (parts.length !== 2) return null;
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10) - getMenuLimitOffsetMinutes(menu);
  }

  function getLatestReservableStartTime(date, storeKey, menu) {
    var mins = getLatestReservableStartMinutes(date, storeKey, menu);
    if (!Number.isFinite(mins)) return "";
    return String(Math.floor(mins / 60)).padStart(2, "0") + ":" + String(mins % 60).padStart(2, "0");
  }

  function validateReservationDateTime(dateLike, storeKey, menu) {
    var date = dateLike instanceof Date ? dateLike : parseAsJSTLocalInput(dateLike);
    if (!date || isNaN(date.getTime())) return { ok: false, key: "invalidDateTime" };

    var business = isBusinessDateTime(date, normalizeStoreKey(storeKey));
    if (!business.ok) return business;

    var latest = getLatestReservableStartMinutes(date, storeKey, menu);
    if (!Number.isFinite(latest) || getJstMinutes(date) > latest) {
      return {
        ok: false,
        key: "latestStart",
        latest: getLatestReservableStartTime(date, storeKey, menu)
      };
    }
    return {
      ok: true,
      latest: getLatestReservableStartTime(date, storeKey, menu)
    };
  }

  function groupSlotsForDisplay(slots) {
    var byDay = {};
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      var ymd = getJstComponents(s.from).ymd;
      if (!byDay[ymd]) byDay[ymd] = [];
      byDay[ymd].push(s);
    }
    Object.keys(byDay).forEach(function (k) {
      byDay[k].sort(function (a, b) { return a.from - b.from; });
    });
    return byDay;
  }

  function isEmptyPeopleValue(v) {
    return v == null || String(v).trim() === "";
  }

  function isPeriodMemoRow(from, to, avail, peopleS, memoS) {
    if (!from || !to) return false;
    if (getJstComponents(from).ymd === getJstComponents(to).ymd) return false;
    if (avail !== 0) return false;
    if (!String(memoS || "").trim()) return false;
    if (isEmptyPeopleValue(peopleS)) return true;
    return parseInt(peopleS, 10) === 0;
  }

  function addDayNote(dayNotes, key, memo) {
    var text = String(memo || "").trim();
    if (!text) return;
    if (!dayNotes[key]) dayNotes[key] = [];
    if (dayNotes[key].indexOf(text) < 0) dayNotes[key].push(text);
  }

  function addPeriodMemoToDayNotes(dayNotes, dayBlocks, from, to, memo) {
    var curJ = getJstComponents(from);
    var endKey = getJstComponents(to).ymd;
    var cur = jstDate(curJ.y, curJ.m, curJ.d, 0, 0, 0);

    while (getJstComponents(cur).ymd <= endKey) {
      var key = getJstComponents(cur).ymd;
      addDayNote(dayNotes, key, memo);
      addDayNote(dayBlocks, key, memo);
      cur = new Date(cur.getTime() + 24 * 60 * 60 * 1000);
    }
  }

  function buildBusinessSlotsFromViewPayload(payload, storeKey, opt) {
    opt = opt || {};
    var minAvail = typeof opt.minAvail === "number" ? opt.minAvail : 1;

    var rows = [];
    if (Array.isArray(payload)) rows = payload;
    else if (payload && Array.isArray(payload.values)) rows = payload.values;
    else if (payload && Array.isArray(payload.dts)) rows = payload.dts;

    // segments を最優先で拾う
    else if (payload && Array.isArray(payload.segments)) rows = payload.segments;

    // slots は次点
    else if (payload && Array.isArray(payload.slots)) rows = payload.slots;
    else if (payload && Array.isArray(payload.data)) rows = payload.data;


    var slots = [];
    var dayNotes = {};
    var dayBlocks = {};
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];

      var fromS, toS, availS;
      var peopleS = null;
      var memoS = "";
      var urlS = "";

      if (Array.isArray(r)) {
        if (r.length === 2) {
          fromS = r[0];
          toS = r[0];
          availS = r[1];
        } else {
          if (r.length < 3) continue;
          fromS = r[0];
          toS = r[1];
          availS = r[2];
          peopleS = (r.length > 3 ? r[3] : null);
          memoS = (r.length > 4 ? r[4] : "");
          urlS = (r.length > 5 ? r[5] : "");
        }
      } else if (r && typeof r === "object") {
        fromS = r.from || r.start || r.fromS || r.startTime;
        toS = r.to || r.end || r.toS || r.endTime;
        availS = (r.avail != null ? r.avail : (r.available != null ? r.available : r.seats));
        peopleS = (r.people != null ? r.people : r.remainingPeople);
        memoS = (r.memo != null ? r.memo : "");
        urlS = (r.url != null ? r.url : "");
      } else {
        continue;
      }

      var from = parseSheetToDateJST(fromS);
      var to = parseSheetToDateJST(toS);
      var avail = parseInt(availS, 10);

      if (!from || isNaN(from.getTime())) continue;
      if (!to || isNaN(to.getTime())) continue;
      if (!Number.isFinite(avail)) continue;

      if (isPeriodMemoRow(from, to, avail, peopleS, memoS)) {
        addPeriodMemoToDayNotes(dayNotes, dayBlocks, from, to, memoS);
        continue;
      }

      if (avail < minAvail) continue;

      var ok = isBusinessDateTime(from, storeKey);
      if (!ok.ok) continue;

      slots.push({
        from: from,
        to: to,
        avail: avail,
        people: (peopleS != null ? parseInt(peopleS, 10) : null),
        memo: memoS || "",
        url: urlS || "",
        ymd: getJstComponents(from).ymd,
        hour: getJstComponents(from).h
      });
    }

    return {
      slots: slots,
      byDay: groupSlotsForDisplay(slots),
      dayNotes: dayNotes,
      dayBlocks: dayBlocks
    };
  }

  window.JIYUCHO_SCHEDULE = {
    parseAsJSTLocalInput: parseAsJSTLocalInput,
    parseSheetToDateJST: parseSheetToDateJST,
    formatJstLocalInput: formatJstLocalInput,
    getJstComponents: getJstComponents,
    getJstMinutes: getJstMinutes,
    isSameJstDay: isSameJstDay,
    isTooLateTomorrowJST: isTooLateTomorrowJST,
    jstDate: jstDate,
    isHolidayInJapan: isHolidayInJapan,
    isInHolidaySeason: isInHolidaySeason,
    checkReservationDate: checkReservationDate,
    isBusinessDateTime: isBusinessDateTime,
    getBusinessHours: getBusinessHours,
    normalizeStoreKey: normalizeStoreKey,
    isLetterReservationMenu: isLetterReservationMenu,
    getMenuLimitOffsetMinutes: getMenuLimitOffsetMinutes,
    getLatestReservableStartTime: getLatestReservableStartTime,
    validateReservationDateTime: validateReservationDateTime,
    buildBusinessSlotsFromViewPayload: buildBusinessSlotsFromViewPayload,
    STORE_RULES: STORE_RULES
  };
})();
